import { getCurrentEnvironment } from "../config/runtime-config";
import { useRampsStore } from "../stores/use-ramps-store";

/**
 * Surfaces the current transactionId on-screen in every non-PROD
 * environment (RAMPS-4453) so it shows up in partner screenshots and we
 * don't have to ask partners to dig it out of their own logs.
 */
export function DebugTransactionIdBadge() {
	const transactionId = useRampsStore((state) => state.transactionId);

	if (getCurrentEnvironment() === "prod" || !transactionId) {
		return null;
	}

	return (
		<div className="fixed top-1 right-1 z-50 select-all rounded bg-background/70 px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">
			{transactionId}
		</div>
	);
}
